import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject, CardStructureConfig, ItemAttrListDataSet } from '@mri/types';

@Pipe({
  name: 'cardTitleRender'
})
export class CardTitleRenderPipe implements PipeTransform {

  transform(date: AnyObject, prop: ItemAttrListDataSet, structure: CardStructureConfig<AnyObject>): string {
    return structure.title(prop);
  }

}
